import { green, grey, purple, red, orange, amber } from '@mui/material/colors';
import { Box } from '@mui/material';
import { ClipStatus } from '@/features/clips/types';

import StatusBadge from './StatusBadge';

// Status component that shows different colors based on status
const StatusIndicator = ({
  status,
  onClickHandler,
}: {
  status: ClipStatus;
  onClickHandler?: () => void;
}) => {
  // Convert status to uppercase for consistent comparison
  const statusUpper = status ? (status.toUpperCase() as ClipStatus) : ('UNKNOWN' as ClipStatus);

  // Get appropriate colors based on status
  const getChipStatusColor = (status: ClipStatus) => {
    switch (status) {
      case 'READY':
        return green.A700;
      case 'ERROR':
        return red[700];
      case 'CANCELED':
        return amber[500];
      case 'PENDING':
        return orange[700];
      case 'NEW':
        return grey[700];
      case 'PROCESSING':
        return orange[200];
      default:
        return purple[700];
    }
  };

  // Get the formatted title. Derived from statusUpper rather than the raw prop
  // so a missing status falls back to 'Unknown' instead of throwing.
  const title = statusUpper.charAt(0) + statusUpper.slice(1).toLowerCase();

  // Check if status is processing for animation
  const isProcessing =
    statusUpper === ClipStatus.PROCESSING || statusUpper === ClipStatus.INITIALIZING;

  return (
    <Box
      component="span"
      onClick={onClickHandler}
      sx={{ display: 'inline-flex', cursor: onClickHandler ? 'pointer' : 'default' }}
    >
      <StatusBadge
        label={title}
        color={getChipStatusColor(statusUpper)}
        pulse={isProcessing}
      />
    </Box>
  );
};

export default StatusIndicator;
